import { getProcedureTooltipLines, getProcedureTooltipTitle } from "../constants/communication_tool_procedure_tooltips";

export default {
  data: () => ({
    procedureTooltipOpen: false,
  }),
  computed: {
    procedureTooltipLines() {
      if (!this.reservation || this.reservation.loading) {
        // 予約未取得時はツール判定を避けてツールチップを無効化
        return null;
      }

      return getProcedureTooltipLines(this.reservation?.toolId);
    },
    procedureTooltipTitle() {
      if (!this.reservation || this.reservation.loading) {
        return null;
      }

      return getProcedureTooltipTitle(this.reservation?.toolId);
    },
  },
  watch: {
    $route() {
      this.procedureTooltipOpen = false; // 画面切替時は残ったツールチップを閉じる
    },
    "reservation.toolId"() {
      this.procedureTooltipOpen = false; // ツール変更時は表示中のツールチップを閉じる
    },
  },
  unmounted() {
    this.procedureTooltipOpen = false;
  },
};
